import { supabase } from "@/integrations/supabase/client";

export const getPhotoUrl = (storagePath: string): string => {
  const { data } = supabase.storage.from("report-photos").getPublicUrl(storagePath);
  return data.publicUrl;
};

export const uploadReportPhotos = async (
  reportId: number,
  userId: string,
  photos: File[]
): Promise<void> => {
  for (const photo of photos) {
    const fileExt = photo.name.split(".").pop();
    const fileName = `${userId}/${reportId}/${crypto.randomUUID()}.${fileExt}`;

    const { error: uploadError } = await supabase.storage
      .from("report-photos")
      .upload(fileName, photo);

    if (uploadError) throw uploadError;

    const { error: insertError } = await (supabase.from as any)("report_photos")
      .insert({ report_id: reportId, storage_path: fileName });

    if (insertError) throw insertError;
  }
};

export const fetchReportPhotos = async (reportId: number): Promise<string[]> => {
  const { data, error } = await (supabase.from as any)("report_photos")
    .select("storage_path")
    .eq("report_id", reportId);

  if (error) throw error;
  return (data || []).map((p) => getPhotoUrl(p.storage_path));
};
